import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
// import '../css/home.css';
import helpers from '../helper';
import moment from 'moment';
import Meta from './layout/Meta';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SliderLoader from '../loader/Slider';
import AboutLoader from '../loader/About';
import ManuLoader from '../loader/Cms';
import SerLoader from '../loader/Service';
import ProductLoader from '../loader/Product';
import BlogLoader from '../loader/Blog';

export default function Home() {
    const [banners, setBanner] = useState([]);
    const [aboutdata, setAboutdata] = useState();
    const [specialties, setSpecialty] = useState([]);
    const [journey, setJourney] = useState([]);
    const [services, setService] = useState([]);
    const [servicesdata, setServicedata] = useState();
    const [manufacturing, setManufacturing] = useState();
    const [weneed, setWeneedData] = useState();
    const [productdata, setProductdata] = useState();
    const [products, setProducts] = useState([]);
    const [clients, setClient] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [blogdata, setBlogdata] = useState();
    const [pageloader, setPageloader] = useState(false);;
    const [aboutloader, setAboutloader] = useState(false);
    const [manufloader, setManufloader] = useState(false);
    const [serloader, setSerloader] = useState(false);
    const [proloader, setProloader] = useState(false);
    const [blogloader, setBlogloader] = useState(false);

    const [contactdata, setContactdata] = useState();
    const [contactlists, setContactlists] = useState([]);

    const [btnloader, setBtnloader] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [companyname, setCompanyname] = useState("");
    const [error, setError] = useState({ name: "", email: "", phone: "", message: "", companyname: "" });



    useEffect(() => {
        setPageloader(true);
        const fetchData = async () => {
            await axios.get(process.env.REACT_APP_API + 'api/banners').then((response) => {
                setBanner(response.data.result);
                setPageloader(false);
            });
        }
        fetchData();
    }, [setBanner]);

    useEffect(() => {
        setAboutloader(true);
        async function aboutdatafunction() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/13')
                .then((response) => {
                    setAboutdata(response.data.result);
                    setAboutloader(false);
                });
        }
        aboutdatafunction();
    }, [setAboutdata]);

    useEffect(() => {
        const fetchData = async () => {
            await axios.get(process.env.REACT_APP_API + 'api/journey').then((response) => {
                setJourney(response.data.result);
            })
        }
        fetchData();
    }, [setJourney]);

    useEffect(() => {
        async function fetchSpecialty() {
            await axios.get(process.env.REACT_APP_API + 'api/ourspecialty')
                .then((response) => {
                    setSpecialty(response.data.result.data);
                });
        }
        fetchSpecialty();
    }, [setSpecialty]);

    useEffect(() => {
        setManufloader(true);
        setSerloader(true);
        async function fetchService() {
            await axios.get(process.env.REACT_APP_API + 'api/services?type=home').then((response) => {
                setService(response.data.result.data);
                setSerloader(false);
            });
        }

        async function fetchServicedata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/14').then((response) => {
                setServicedata(response.data.result);
            });
        }

        async function fetchManufacturingdata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/15').then((response) => {
                setManufacturing(response.data.result);
                setManufloader(false);
            });
        }

        async function fetchNeeddata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/16').then((response) => {
                setWeneedData(response.data.result);
            });
        }

        fetchServicedata();
        fetchService();
        fetchManufacturingdata();
        fetchNeeddata();

    }, [setService]);

    useEffect(() => {
        setProloader(true);
        async function fetchProductdata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/17').then((response) => {
                setProductdata(response.data.result);
                setProloader(false);
            });
        }

        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/products?type=home')
                .then((response) => {
                    setProducts(response.data.result.data);
                });
        }
        fetchData();
        fetchProductdata();
    }, [setProducts]);

    useEffect(() => {
        setBlogloader(true);
        async function fetchBlogdata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/18').then((response) => {
                setBlogdata(response.data.result);
            });
        }

        const fetchData = async () => {
            await axios.get(process.env.REACT_APP_API + 'api/blogs?type=topblogs').then((response) => {
                setBlogs(response.data.result.data);
                setBlogloader(false);
            });
        }
        fetchData();
        fetchBlogdata();
    }, [setBlogs]);

    useEffect(() => {
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/clients')
                .then((response) => {
                    setClient(response.data.result.data);
                });
        }
        fetchData();
    }, [setClient]);

    useEffect(() => {

        async function fetchContactdata() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/19').then((response) => {
                setContactdata(response.data.result);
            });
        }

        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/contacts?type=home')
                .then((response) => {
                    setContactlists(response.data.result.data);
                });
        }
        fetchData();
        fetchContactdata();

    }, [setContactlists]);

    async function ContactForm(e) {
        e.preventDefault();
        setBtnloader(true);
        setError({ name: "", email: "", phone: "", message: "", companyname: "" });
        let callback = { name: name, email: email, phone: phone, message: message, companyname: companyname }
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        await axios.post(process.env.REACT_APP_API + 'api/contactform', callback, config)
            .then((response) => {
                toast.success(response.data.message);
                setBtnloader(false);
                setName("");
                setEmail("");
                setPhone("");
                setCompanyname("");
                setMessage("");
            })
            .catch((errors) => {
                if (errors.response !== undefined) {
                    let rterror = errors.response.data.errors;
                    setError({
                        name: rterror?.name?.[0],
                        email: rterror?.email?.[0],
                        phone: rterror?.phone?.[0],
                        message: rterror?.message?.[0],
                        companyname: rterror?.companyname?.[0]
                    });
                    setBtnloader(false);
                }
            });
    }



    return (
        <>
            <Meta id={1} />
            <main>
            {
                    pageloader ?
                        <SliderLoader />
                        :

                        banners.length > 0 ?
                            <section className={'Slider Home'}>
                                <Carousel fade nextIcon="" prevIcon="" interval={4000} pause={false}>
                                    {
                                        banners.map((banner, br) =>
                                            <Carousel.Item className="carousel-item" key={br}>
                                                {
                                                    helpers.helpers1(banner.image) ?
                                                        <picture>
                                                            <img src={process.env.REACT_APP_IMAGE + 'uploads/banner/' + banner.image} alt={banner.image_alt} width="1600" height="650" />
                                                        </picture>
                                                        :
                                                        <picture>
                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/banner/webp/' + banner.image + '.webp'} type="image/webp" />
                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/banner/avif/' + banner.image + '.avif'} type="image/avif" />
                                                            <img src={process.env.REACT_APP_IMAGE + 'uploads/banner/jpg/' + banner.image + '.jpg'} alt={banner.image_alt} width="1600" height="650" />
                                                        </picture>
                                                }
                                                <Carousel.Caption className="carousel-caption">
                                                    <div className="container my-5">
                                                        <div className="row justify-content-center text-center">
                                                            <div className="col-12 col-lg-8 col-md-10">
                                                                {/* <h4 className="h5">{</h4> */}
                                                                <h2 className="title text-u h1">{banner.image_alt}</h2>
                                                                <div className="text-secondary" dangerouslySetInnerHTML={{ __html: banner.description }} />
                                                                {
                                                                    banner.link !== '' || banner.link !== '#' ?

                                                                        <a href={banner.link} className="btn btn-thm">Read More <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></a>
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Carousel.Caption>
                                            </Carousel.Item>
                                        )
                                    }
                                </Carousel>
                            </section>
                        :
                        ''

                }

                {
                    aboutloader ?
                        <AboutLoader />
                        :
                        aboutdata || specialties.length > 0 ?



                        <section className="BannerBottom grey">
                            <div className="container">
                                {
                                    aboutdata ?
                                        <>
                                            <div className="text-center">
                                                <span className="SubTitle">{aboutdata.title}</span>
                                                <h1 className="Heading"><strong>{aboutdata.heading}</strong></h1>
                                            </div>
                                            <div className="row justify-content-center">
                                                <div className="col-lg-9 col-md-10 text-center" dangerouslySetInnerHTML={{ __html: aboutdata.description }} />
                                            </div>
                                        </>
                                        :
                                        ''
                                }
                                {
                                    specialties.length > 0 ?
                                        <div className="row mt-5 text-center justify-content-center">
                                            {
                                                specialties.map((specialties, sp) =>
                                                    <div className="col-md-4" key={sp}>
                                                        <div className="card card-body p-4">
                                                            {
                                                                helpers.helpers1(specialties.image) ?
                                                                    <picture>
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/specialty/' + specialties.image} alt={specialties.title} width="90" height="90" />
                                                                    </picture>
                                                                    :
                                                                    <picture>
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/specialty/webp/' + specialties.image + '.webp'} type="image/webp" />
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/specialty/avif/' + specialties.image + '.avif'} type="image/avif" />
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/specialty/jpg/' + specialties.image + '.jpg'} alt={specialties.title} width="90" height="90" />
                                                                    </picture>
                                                            }
                                                            <h3 className="h5 fw-bold">{specialties.title}</h3>
                                                            <p>{specialties.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        :
                                        ''
                                }
                            </div>
                        </section>

                        : ''
                }

                {
                    journey.length > 0 ?
                        <section className="bgimg MyCarouselSec bgthm2 YearByYear">
                            <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="wmap" className="imgbg" width="1600" height="453" />
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <OwlCarousel items={5} className="MyCarousel" loop margin={0} nav={true} dots={false} navElement={'span'} navText={''} responsive={{ 0: { items: 1 }, 350: { items: 2 }, 460: { items: 2 }, 600: { items: 3 }, 768: { items: 3 }, 992: { items: 4 }, 1200: { items: 4 }, 1600: { items: 5 } }}>
                                            {
                                                journey.map((jour, j) =>
                                                    <div className="YearBox CarBlock" key={j}>
                                                        <div className="Year">
                                                            <h2 className="m-0">{jour.year}</h2>
                                                        </div>
                                                        <div className="Msg">
                                                            <div className="MsgBox">{jour.title}</div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </OwlCarousel>
                                    </div>
                                </div>
                            </div>
                        </section>
                        :
                        ''
                }


                {
                    serloader ?
                        <SerLoader />
                        :
                        services.length > 0 ?
                            <section className="Sec2 Home">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="#330fa1" viewBox="0 0 438.14 408.8"><path d="M280.41,38.37c-33.27-86.32,157.73,0,157.73,0V408.81H0v-135s60.87-94.4,163.76-84.05C250.83,198.53,341.2,196.07,280.41,38.37Z" /></svg>
                                <div className="container mb-5">
                                    {
                                        servicesdata ?
                                            <div className="row justify-content-center">
                                                <div className="col-12 col-lg-8 text-center">
                                                    <span className="SubTitle">{servicesdata.title}</span>
                                                    <h2 className="Heading"><strong>{servicesdata.heading}</strong></h2>
                                                    <div dangerouslySetInnerHTML={{ __html: servicesdata.description }} />
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }

                                    <div className="row">
                                        {
                                            services.map((service, sr) =>
                                                <div className="col-md-6 mb-4" key={sr}>
                                                    <Link to={'/service/' + service.alias} className="card SerBlock">
                                                        <div className="card-header">
                                                            {
                                                                helpers.helpers1(service.image) ?
                                                                    <picture className="img">
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/' + service.image} alt={service.title} width="60" height="60" />
                                                                    </picture>
                                                                    :
                                                                    <picture className="img">
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/webp/' + service.image + '.webp'} type="image/webp" />
                                                                        <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/service/avif/' + service.image + '.avif'} type="image/avif" />
                                                                        <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/service/jpg/' + service.image + '.jpg'} alt={service.title} width="60" height="60" />
                                                                    </picture>
                                                            }
                                                        </div>
                                                        <div className="card-body px-4">
                                                            <h3 className="h5">{service.title}</h3>
                                                            <p>{service.short_description}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </section>
                            :

                            ''
                }

                {
                    manufloader ?
                        <ManuLoader />
                        :
                        manufacturing ?

                            <section className="Sec3">
                                <div className="container">
                                    <div className="text-center">
                                        <span className="SubTitle">{manufacturing.title}</span>
                                        <h2 className="Heading">{manufacturing.heading}</h2>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-lg-6 order-lg-last">
                                            <div className="img ms-lg-5 rounded-4 overflow-hidden">
                                                {
                                                    helpers.helpers1(manufacturing.image) ?
                                                        <picture>
                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/' + manufacturing.image} alt={manufacturing.title} width="1600" height="650" />
                                                        </picture>
                                                        :
                                                        <picture>
                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/webp/' + manufacturing.image + '.webp'} type="image/webp" />
                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/avif/' + manufacturing.image + '.avif'} type="image/avif" />
                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/jpg/' + manufacturing.image + '.jpg'} alt={manufacturing.title} width="1600" height="650" />
                                                        </picture>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div dangerouslySetInnerHTML={{ __html: manufacturing.description }} />
                                            <Link to="/manufacturing" className="btn btn-thm">Read More <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></Link>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            :
                            ''
                }

                {/* {
                    weneed ?

                        <section className="bgimg bgthm">
                            <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="wmap" className="imgbg" width="1600" height="453" />
                            <div className="container">
                                <div className="row justify-content-center text-center">
                                    <div className="col-md-8 col-12">
                                        <span className="SubTitle text-white">{weneed.title}</span>
                                        <h2 className="Heading thm1">{weneed.heading}</h2>
                                        <div className="text-white" dangerouslySetInnerHTML={{ __html: weneed.description }} />
                                        <Link to="/contact" className="btn btn-thm">Let's Talk <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></Link>
                                    </div>
                                </div>
                            </div>
                        </section>

                        : ''

                } */}

                {
                    proloader ?
                        <ProductLoader />
                        :
                        products.length > 0 ?
                            <section className="ProSec MyCarouselSec InHome">
                                <div className="container">
                                    {
                                        productdata ?
                                            <div className="row justify-content-center">
                                                <div className="col-12 col-lg-8 text-center">
                                                    <span className="SubTitle">{productdata.title}</span>
                                                    <h2 className="Heading"><strong>{productdata.heading}</strong></h2>
                                                    <div dangerouslySetInnerHTML={{ __html: productdata.description }} />
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }
                                    <OwlCarousel className="MyCarousel" items={4} margin={20} loop={false} nav={true} dots={false} responsive={{ 0: { items: 1 }, 350: { items: 1 }, 460: { items: 2 }, 600: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 4 }, 1600: { items: 4 } }}>
                                        {
                                            products.map((product, p) =>
                                                <Link to={"/product/" + product.alias} key={p} className="card ProBlock CarBlock">
                                                    <div className="card-header">
                                                        {
                                                            helpers.helpers1(product.image) ?
                                                                <picture className="img">
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/product/' + product.image} alt={product.title} width="121" height="131" />
                                                                </picture>
                                                                :
                                                                <picture className="img">
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/webp/' + product.image + '.webp'} type="image/webp" />
                                                                    <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/product/avif/' + product.image + '.avif'} type="image/avif" />
                                                                    <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/product/jpg/' + product.image + '.jpg'} alt={product.title} width="121" height="131" />
                                                                </picture>
                                                        }
                                                    </div>
                                                    <div className="card-body text-center">
                                                        <h3>{product.title}</h3>
                                                        <span className="p-2 rounded-circle"><img src={require("../assets/img/arrow1.svg").default} height="18" width="18" alt="Product Name" /></span>
                                                    </div>
                                                </Link>
                                            )
                                        }
                                    </OwlCarousel>
                                    <div className="text-center">
                                        <Link to="/products" className="btn btn-thm">View all Product <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></Link>
                                    </div>
                                </div>
                            </section>

                            :
                            ''
                }

                {
                    clients.length > 0 ?
                        <section className="Sec5 grey p-0">
                            <div className="row">
                                <div className="col-lg-2 col-md-3 p-0">
                                    <div className="bgthm text-center text-lg-end text-white text-u h2 h-100 d-grid align-items-center p-4 lh-n m-0 ps-lg-5">Our Clients</div>
                                </div>
                                <div className="col-lg-10 col-md-9 p-0 py-md-4">
                                    <OwlCarousel items={6} autoplay={true} margin={8} loop={true} dots={false} nav={false} className="SliderBox" responsive={{ 0: { items: 3 }, 350: { items: 3 }, 460: { items: 4 }, 600: { items: 4 }, 768: { items: 5 }, 992: { items: 5 }, 1200: { items: 6 }, 1600: { items: 6 } }}>
                                        {
                                            clients.map((client, cl) =>
                                                <div key={cl}>
                                                    {
                                                        helpers.helpers1(client.image) ?
                                                            <picture className="img">
                                                                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/clients/' + client.image} alt={client.title} className="w-100" width="150" height="100" />
                                                            </picture>
                                                            :
                                                            <picture className="img">
                                                                <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/clients/webp/' + client.image + '.webp'} type="image/webp" />
                                                                <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/clients/avif/' + client.image + '.avif'} type="image/avif" />
                                                                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/clients/jpg/' + client.image + '.jpg'} alt={client.title} className="w-100" width="150" height="100" />
                                                            </picture>
                                                    }
                                                </div>
                                            )
                                        }
                                    </OwlCarousel>
                                </div>
                            </div>
                        </section>
                        : ''
                }

                {
                    blogloader ?
                        <BlogLoader />
                        :
                        blogs.length > 0 ?

                            <section className="Sec4 MyCarouselSec">
                                <div className="container">
                                    {
                                        blogdata ?
                                            <div className="row justify-content-center">
                                                <div className="col-12 col-lg-8 text-center">
                                                    <span className="SubTitle">{blogdata.title}</span>
                                                    <h2 className="Heading"><strong>{blogdata.heading}</strong></h2>
                                                    <div dangerouslySetInnerHTML={{ __html: blogdata.description }} />
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <OwlCarousel items={3} margin={8} loop={true} className="Blog MyCarousel" responsive={{ 0: { items: 1 }, 350: { items: 1 }, 460: { items: 2 }, 600: { items: 2 }, 768: { items: 2 }, 992: { items: 3 }, 1200: { items: 3 }, 1600: { items: 3 } }}>
                                                {
                                                    blogs.map((blog, b) =>
                                                        <Link to={"/blog/" + blog.alias} key={b} className="card BlogBlock CarBlock">
                                                            <div className="card-header">
                                                                {
                                                                    helpers.helpers1(blog.image) ?
                                                                        <picture className="img">
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/blog/' + blog.image} alt={blog.title} width="121" height="131" />
                                                                        </picture>
                                                                        :
                                                                        <picture className="img">
                                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/blog/webp/' + blog.image + '.webp'} type="image/webp" />
                                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/blog/avif/' + blog.image + '.avif'} type="image/avif" />
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/blog/jpg/' + blog.image + '.jpg'} alt={blog.title} width="121" height="131" />
                                                                        </picture>
                                                                }
                                                            </div>
                                                            <div className="card-body px-0 mt-1 text-center">
                                                                <span className="thm small">{moment(blog.post_date).format('DD MMMM YYYY')}</span>
                                                                <h3 className="h5 mt-2 fw-semibold">{blog.title}</h3>
                                                            </div>
                                                        </Link>
                                                    )
                                                }
                                            </OwlCarousel>
                                        </div>
                                    </div>
                                    <div className="text-center"><Link to="/blogs" className="btn btn-thm">View all Blogs <img src={require("../assets/img/arrow1-w.svg").default} width="24" height="24" alt="arrow" /></Link></div>
                                </div>
                            </section>
                            :
                            ''
                }

                {
                    contactlists.length > 0 ?

                        <section className="Sec6 grey Contact">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#00547c" viewBox="0 0 659.03 120"><path d="M0,0S163.8,74.08,329.1,74.08C493.31,74.08,659,0,659,0V257.85H0Z" /></svg>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        {
                                            contactdata ?
                                                <>
                                                    <span className="SubTitle">{contactdata.title}</span>
                                                    <h2 className="h1 text-black lh-n">{contactdata.heading} <strong></strong></h2>
                                                    <div dangerouslySetInnerHTML={{ __html: contactdata.description }} />
                                                </>
                                                :

                                                ''
                                        }

                                        {
                                            contactlists.length > 0 && contactlists.map((lists, co) =>
                                                <div className="ConInfo mt-4" key={co}>
                                                    <ul className="mb-4">
                                                        {
                                                            lists.address ?
                                                                <li><img src={require("../assets/img/location.svg").default} alt="Address" width="42" height="42" /> <span>{lists.address}</span></li>
                                                                :
                                                                ''
                                                        }
                                                        {
                                                            lists.phone ?
                                                                <li>
                                                                    <img src={require("../assets/img/call.svg").default} width="42" height="42" alt="Call" />
                                                                    <span>
                                                                        {
                                                                            helpers.helpers2(lists.phone).map((phones, ph) =>
                                                                                <a key={ph} href={"tel:" + phones} className="d-block">{phones}</a>
                                                                            )
                                                                        }

                                                                    </span>
                                                                </li>
                                                                : ''
                                                        }
                                                        {
                                                            lists.email ?
                                                                <li>
                                                                    <img src={require("../assets/img/mail.svg").default} width="42" height="42" alt="email" />
                                                                    <span>
                                                                        <a href="mailto:info@pesinstallations.com">{lists.email}</a>
                                                                    </span>
                                                                </li>
                                                                : ''
                                                        }
                                                    </ul>
                                                    <hr />
                                                </div>

                                            )
                                        }



                                    </div>
                                    <div className="col-lg-8">
                                        <form id="formsubmit" onSubmit={ContactForm} className="bg-white rounded-4 ms-lg-5">
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label htmlFor="Name" className="form-label m-0">Your Name <small className='text-danger'>*</small> </label>
                                                    <input className="form-control" placeholder='Enter Your Name Here...' id="Name" value={name} onChange={(e) => setName(e.target.value)} type="text" />
                                                    {error.name ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.name}</span> : ''}
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label htmlFor="cName" className="form-label m-0">Your Company Name</label>
                                                    <input className="form-control" id="cName" placeholder='Enter Company Name Here...' value={companyname} onChange={(e) => setCompanyname(e.target.value)} type="text" />
                                                    {error.companyname ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.companyname}</span> : ''}
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label htmlFor="Email" className="form-label m-0">Your Email ID <small className='text-danger'>*</small></label>
                                                    <input className="form-control" id="Email" placeholder='Enter Email Id Here...' value={email} onChange={(e) => setEmail(e.target.value)} type="text" />
                                                    {error.email ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.email}</span> : ''}
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label htmlFor="Contact" className="form-label m-0">Your Contact No <small className='text-danger'>*</small></label>
                                                    <input className="form-control" id="Contact" placeholder='Enter Contact No Here...' value={phone} onChange={(e) => setPhone(e.target.value)} type="number" maxLength="10" />
                                                    {error.phone ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.phone}</span> : ''}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Message" className="form-label m-0">Message <small className='text-danger'>*</small></label>
                                                    <textarea className="form-control" id="Message" placeholder='Enter Message Here...' value={message} onChange={(e) => setMessage(e.target.value)} ></textarea>
                                                    {error.message ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.message}</span> : ''}
                                                </div>
                                            </div>
                                            {
                                                btnloader ?
                                                    <button type="button" className="btn btn-thm disabled"><FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" /> Loading...</button>
                                                    :
                                                    <button type="submit" name="submit" className="btn btn-thm">Submit</button>
                                            }
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                        : ''
                }

            </main>
        </>
    )
}
